import { getDynamicContentResp } from "./dynamicContentObjectMocks/getDynamicContentResp";
import { getDynamicContentSettingsResp } from "./dynamicContentObjectMocks/getDynamicContentSettingsResp";
import { bvrExclusions } from "./dynamicContentObjectMocks/bvrExclusionsResp";
import AppUtils from "@src/utils/appUtils";

export function fetchBvrExclusions() {
  const response = bvrExclusions;
  return AppUtils.simulateResponse(response);
}

export function getDynamicContentSettings() {
  let response = getDynamicContentSettingsResp;
  return AppUtils.simulateResponse(response);
}

export async function getDynamicContent(lang, industry) {
  let response = await getDynamicContentResp(lang, industry);
  return AppUtils.simulateResponse(response);
}

export function saveDynamicContent() {
  const response = { result: 100 };
  return AppUtils.simulateResponse(response);
}

export function deleteDynamicContent() {
  const response = { result: 100 };
  return AppUtils.simulateResponse(response);
}
